import BaseAbility from 'umg-ember-backend/abilities/base';

export default class WebSeriesAbility extends BaseAbility {}
